/* @flow */
import React from 'react';

export default function GDCDataTransferToolIcon({
  style
}: Object): React.Element {
  return (<span className="icon icon-gdc-data-transfer-tool">
            <span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span><span className="path6"></span><span className="path7"></span><span className="path8"></span>
          </span>);
}
